export const GET_LANGUAGES = 'GET_LANGUAGES'
export const GET_ABOUT_CONTENT = 'GET_ABOUT_CONTENT'
